import {
  AiOutlineDashboard,
  AiOutlineToTop,
  AiOutlineWallet,
} from "react-icons/ai";
import { BiTransfer } from "react-icons/bi";

import { GiTakeMyMoney } from "react-icons/gi";
import { FiUser, FiSettings } from "react-icons/fi";

import { MdOutlineSupportAgent } from "react-icons/md";

import { RiTeamLine, RiMoneyDollarCircleLine } from "react-icons/ri";
export const menus = [
  // ******************** user dashboard menu ************************//
  {
    id: "337fwedkf",
    menu: "dashboard",
    icon: <AiOutlineDashboard />,
    route: "/dashboard",
    permission: ["admin"],
  },
  {
    id: "337fwedkf",
    menu: "landingPage.pages.dashboard",
    icon: <AiOutlineDashboard />,
    route: "/dashboard",
    permission: ["user"],
  },
  {
    id: "7dfser8srf",
    menu: "userPanel.sideBarMenus.profile.title",
    icon: <FiUser />,
    permission: ["user"],
    dropdown: [
      {
        id: "8389r4ifd",
        menu: "userPanel.sideBarMenus.profile.subMenu.myProfile",
        route: "/dashboard/profile/my-profile",
        permission: ["user"],
      },
      {
        id: "f7d8e8sfrw",
        menu: "userPanel.sideBarMenus.profile.subMenu.editProfile",
        route: "/dashboard/profile/edit-profile",
        permission: ["user"],
      },
      {
        id: "sf7s8f5s8er",
        menu: "userPanel.sideBarMenus.profile.subMenu.updatePassword",
        route: "/dashboard/profile/update-password",
        permission: ["user"],
      },
      // Uncomment if needed and define translation key in JSON
      // {
      //   id: "sfs4f8se8",
      //   menu: "userPanel.sideBarMenus.profile.subMenu.updateEmail",
      //   route: "/dashboard/profile/update-email",
      //   permission: ["user"],
      // },
      {
        id: "d7f8wer8s",
        menu: "userPanel.sideBarMenus.profile.subMenu.editWallet",
        route: "/dashboard/profile/edit-wallet",
        permission: ["user"],
      },
      {
        id: "d7f8we3ap",
        menu: "userPanel.sideBarMenus.profile.subMenu.addPin", // Add this key in your i18n file
        route: "/dashboard/profile/add-pin",
        permission: ["user"],
      },
      {
        id: "d7f8wekeieyejheap",
        menu: "userPanel.sideBarMenus.profile.subMenu.addKyc",
        route: "/dashboard/profile/add-kyc",
        permission: ["user"],
      },
    ],
  },

  {
    id: "f7df8sfd7f",
    menu: "userPanel.sideBarMenus.wallet.title",
    icon: <AiOutlineWallet />,
    permission: ["user"],
    dropdown: [
      {
        id: "7854s8dfs5d",
        menu: "userPanel.sideBarMenus.wallet.subMenu.myWallet",
        route: "/dashboard/wallet/my-wallet",
        permission: ["user"],
      },
      {
        id: "8s8dfdepser",
        menu: "userPanel.sideBarMenus.wallet.subMenu.depositFund",
        icon: <RiMoneyDollarCircleLine />,
        route: "/dashboard/wallet/deposit-fund",
        permission: ["user"],
      },
      {
        id: "fd7d8s48574",
        menu: "userPanel.sideBarMenus.wallet.subMenu.depositHistory",
        route: "/dashboard/wallet/deposit-history",
        permission: ["user"],
      },
    ],
  },
  {
    id: "df79er8suf",
    menu: "userPanel.sideBarMenus.team.title",
    icon: <RiTeamLine />,
    permission: ["user"],
    dropdown: [
      {
        id: "r3er8re8sdf7dn",
        menu: "userPanel.sideBarMenus.team.subMenu.directTeam",
        route: "/dashboard/team/direct-team",
        permission: ["user"],
      },
      {
        id: "fs7erw55s",
        menu: "userPanel.sideBarMenus.team.subMenu.levelTeam",
        route: "/dashboard/team/level-team",
        permission: ["user"],
      },
      {
        id: "fs7erw55ssts",
        menu: "userPanel.sideBarMenus.team.subMenu.teamLine",
        route: "/dashboard/team/team-business",
        permission: ["user"],
      },
    ],
  },
  {
    id: "m5vko5f5sfo3s5f",
    menu: "userPanel.sideBarMenus.topUp.title",
    icon: <AiOutlineToTop />,
    permission: ["user"],
    dropdown: [
      // {
      //   id: "fnd5fhs5or5f",
      //   menu: "userPanel.sideBarMenus.topUp.subMenu.package",
      //   route: "/dashboard/topup/topup-account",
      //   permission: ["user"],
      // },
      {
        id: "vnzs5dajio5df8",
        menu: "userPanel.sideBarMenus.topUp.subMenu.packageHistory",
        route: "/dashboard/topup/topup-history",
        permission: ["user"],
      },
    ],
  },
  {
    id: "fsfsfusf8se4r",
    menu: "userPanel.sideBarMenus.myEarning.title",
    icon: <GiTakeMyMoney />,
    permission: ["user"],
    dropdown: [
      {
        id: "fs55s8fs8fs",
        menu: "userPanel.sideBarMenus.myEarning.subMenu.roiIncome",
        route: "/dashboard/earnings/roi-income",
        permission: ["user"],
      },
      {
        id: "e7rfs5fs25gsenbv",
        menu: "userPanel.sideBarMenus.myEarning.subMenu.levelIncome",
        route: "/dashboard/earnings/level-income",
        permission: ["user"],
      },
      {
        id: "e7rfs5fs25gsenbv",
        menu: "userPanel.sideBarMenus.myEarning.subMenu.profitSharingIncome",
        route: "/dashboard/earnings/profit-sharing-income",
        permission: ["user"],
      },
      {
        id: "fs55s8fs8fssstrs",
        menu: "userPanel.sideBarMenus.myEarning.subMenu.rewardIncome",
        route: "/dashboard/earnings/reward-income",
        permission: ["user"],
      },
      // {
      //   id: "fs55s8fdiejeues",
      //   menu: "userPanel.sideBarMenus.myEarning.subMenu.pollIncome",
      //   route: "/dashboard/earnings/poll-income",
      //   permission: ["user"],
      // },
      // Uncomment if you add keys later
      // {
      //   id: "7jsuuwer7f8sf",
      //   menu: "userPanel.sideBarMenus.myEarning.subMenu.bonusIncome",
      //   route: "/dashboard/earnings/bonus-income",
      //   permission: ["user"],
      // },
      // {
      //   id: "fdf8s8f8s8fs",
      //   menu: "userPanel.sideBarMenus.myEarning.subMenu.reward",
      //   route: "/dashboard/earnings/reward",
      //   permission: ["user"],
      // },
    ],
  },
  {
    id: "bv2sre2ws7sf",
    menu: "userPanel.sideBarMenus.withdraw.title",
    icon: <BiTransfer />,
    permission: ["user"],
    dropdown: [
      {
        id: "vv4mk4ufi4sf",
        menu: "userPanel.sideBarMenus.withdraw.subMenu.withdrawFunds",
        route: "/dashboard/withdraw/withdraw-fund",
        permission: ["user"],
      },
      {
        id: "vn2sff47s7f7d",
        menu: "userPanel.sideBarMenus.withdraw.subMenu.withdrawHistory",
        route: "/dashboard/withdraw/withdraw-history",
        permission: ["user"],
      },
    ],
  },
  {
    id: "vn3es6uru3sf7",
    menu: "userPanel.sideBarMenus.support.title",
    icon: <MdOutlineSupportAgent />,
    permission: ["user"],
    dropdown: [
      {
        id: "sfs4f4s8e8r",
        menu: "userPanel.sideBarMenus.support.subMenu.updates",
        route: "/dashboard/support/updates",
        permission: ["user"],
      },
      {
        id: "vmj4dfs4f8sf",
        menu: "userPanel.sideBarMenus.support.subMenu.supportTicket",
        route: "/dashboard/support/support-ticket",
        permission: ["user"],
      },
      {
        id: "vmj4de4ru4sf7s7",
        menu: "userPanel.sideBarMenus.support.subMenu.ticketHistory",
        route: "/dashboard/support/ticket-history",
        permission: ["user"],
      },
      {
        id: "f7s8f8fd",
        menu: "userPanel.sideBarMenus.support.subMenu.contactUs",
        route: "/dashboard/support/contact-us",
        permission: ["user"],
      },
    ],
  },

  // ************************************* admin dashboard menu ************************//
  {
    id: "7dfsegrr8srf",
    menu: "Member",
    icon: <FiUser />,
    permission: ["admin"],
    dropdown: [
      {
        id: "83agr89r4ifd",
        menu: "All Member",
        route: "/dashboard/member/all-member",
        permission: ["admin"],
      },
      {
        id: "838dga9r4ifd",
        menu: "Active Member",
        route: "/dashboard/member/active-member",
        permission: ["admin"],
      },
      {
        id: "838dga9ifd",
        menu: "Blocked Member",
        route: "/dashboard/member/blocked-member",
        permission: ["admin"],
      },
      {
        id: "838dga93up",
        menu: "User PIN",
        route: "/dashboard/member/user-pin",
        permission: ["admin"],
      },
      {
        id: "1458s8e88wer",
        menu: "Team Statistics",
        route: "/dashboard/member/team-statistics",
        permission: ["admin"],
      },
      {
        id: "1458s8e88werrer",
        menu: "Wallet Address",
        route: "/dashboard/member/address-history",
        permission: ["admin"],
      },
      {
        id: "1458srer",
        menu: "All KYC",
        route: "/dashboard/member/all-kyc",
        permission: ["admin"],
      },
      {
        id: "1458skdjeueyherer",
        menu: "All Inquiry",
        route: "/dashboard/member/all-inquiry",
        permission: ["admin"],
      },
    ],
  },
  {
    id: "7dfsrs8srf",
    menu: "Deposit Report",
    icon: <GiTakeMyMoney />,
    permission: ["admin"],
    dropdown: [
      {
        id: "83bhi9r4ifd",
        menu: "All Transaction",
        route: "/dashboard/deposit/all-deposit",
        permission: ["admin"],
      },
      {
        id: "838keiedujeuyifd",
        menu: "Pending Report",
        route: "/dashboard/deposit/pending-deposit",
        permission: ["admin"],
      },
      {
        id: "838dsoifd",
        menu: "Successful Report",
        route: "/dashboard/deposit/successful-deposit",
        permission: ["admin"],
      },
      {
        id: "8shbga9ifd",
        menu: "Rejected Report",
        route: "/dashboard/deposit/rejected-deposit",
        permission: ["admin"],
      },
    ],
  },
  {
    id: "7dfskdju8srf",
    menu: "Manage Deposit",
    icon: <GiTakeMyMoney />,
    permission: ["admin"],
    dropdown: [
      {
        id: "83oeieuej9r4ifd",
        menu: "Manage Deposit",
        route: "/dashboard/deposit/manage-deposit",
        permission: ["admin"],
      },
      {
        id: "83ieueyoifd",
        menu: "Manage Deposit History",
        route: "/dashboard/deposit/manage-deposit-history",
        permission: ["admin"],
      },
    ],
  },
  {
    id: "7dfskddkdjkhed",
    menu: "Manage Poll",
    icon: <GiTakeMyMoney />,
    permission: ["admin"],
    dropdown: [
      {
        id: "83oeieuej9dkieehifd",
        menu: "Manage Poll",
        route: "/dashboard/poll/manage-poll",
        permission: ["admin"],
      },
      // {
      //   id: "83ieueyoifd",
      //   menu: "Manage Deposit History",
      //   route: "/dashboard/deposit/manage-deposit-history",
      //   permission: ["admin"],
      // },
    ],
  },
  {
    id: "7dfsrs8srftopup",
    menu: "Package Report",
    icon: <GiTakeMyMoney />,
    permission: ["admin"],
    dropdown: [
      {
        id: "83bhi9r4ifdtpup",
        menu: "All Package",
        route: "/dashboard/topup/all-top-up-history",
        permission: ["admin"],
      },
      {
        id: "83bhdkiejeyfdtpup",
        menu: "Pending Package",
        route: "/dashboard/topup/pending-top-up-history",
        permission: ["admin"],
      },
      {
        id: "83bhddkdjhyeleyfdtpup",
        menu: "Success Package",
        route: "/dashboard/topup/success-top-up-history",
        permission: ["admin"],
      },
      {
        id: "83bhddkdjhyeleyfdtpup",
        menu: "Reject Package",
        route: "/dashboard/topup/reject-top-up-history",
        permission: ["admin"],
      },
      {
        id: "83bhi9rdjkdeuejdpup",
        menu: "Sell Package",
        route: "/dashboard/topup/sell-package",
        permission: ["admin"],
      },
    ],
  },
  {
    id: "ajjdrs8srf",
    menu: "withdraw",
    icon: <AiOutlineWallet />,
    permission: ["admin"],
    dropdown: [
      {
        id: "dajei9r4ifd",
        menu: "All Withdraw",
        route: "/dashboard/Withdraw/all-withdraw",
        permission: ["admin"],
      },
      {
        id: "ajodldkieueuejifd",
        menu: "Pending Withdraw",
        route: "/dashboard/Withdraw/pending-withdraw",
        permission: ["admin"],
      },
      {
        id: "ajobeoifd",
        menu: "Successful Withdraw",
        route: "/dashboard/Withdraw/successful-withdraw",
        permission: ["admin"],
      },
      {
        id: "aubia9ifd",
        menu: "Rejected Withdraw",
        route: "/dashboard/Withdraw/rejected-withdraw",
        permission: ["admin"],
      },
    ],
  },
  {
    id: "4343qf3q2f",
    menu: "earning",
    icon: <GiTakeMyMoney />,
    permission: ["admin"],
    dropdown: [
      {
        id: "f5sf5s8fs8f",
        menu: "Roi income",
        route: "/dashboard/earnings/roi-income",
        permission: ["admin"],
      },
      {
        id: "34qqf43gq3hq",
        menu: "Level Income",
        route: "/dashboard/earnings/level-income",
        permission: ["admin"],
      },
      {
        id: "7885s8sf8sf",
        menu: "Profit Sharing income",
        route: "/dashboard/earnings/profit-sharing-income",
        permission: ["admin"],
      },
      {
        id: "f5sf5s8fs8frank",
        menu: "Reward income",
        route: "/dashboard/earnings/reward-income",
        permission: ["admin"],
      },
      {
        id: "f5sf5s8fsdkeuenk",
        menu: "Poll income",
        route: "/dashboard/earnings/poll-income",
        permission: ["admin"],
      },

      // hide reward
      // {
      //   id: "f5sf5s8fs8fnaj3w",
      //   menu: "Reward",
      //   route: "/dashboard/earnings/admin-reward",
      //   permission: ["admin"],
      // },
    ],
  },
  {
    id: "nf4au4awg43",
    menu: "Support",
    icon: <MdOutlineSupportAgent />,
    permission: ["admin"],
    dropdown: [
      {
        id: "98ay9uva",
        menu: "Contact Us",
        route: "/dashboard/contact-us",
        permission: ["admin"],
      },
      {
        id: "30ht9fwa",
        menu: "Ticket Data",
        route: "/dashboard/ticket-data",
        permission: ["admin"],
      },
      {
        id: "30ht9fca",
        menu: "Create News",
        route: "/dashboard/create-update",
        permission: ["admin"],
      },
    ],
  },
  {
    id: "sf4s8f7ser",
    menu: "Setting",
    icon: <FiSettings />,
    permission: ["admin"],
    dropdown: [
      {
        id: "f4s8fe8r8",
        menu: "Change Password",
        route: "/dashboard/change-password",
        permission: ["admin"],
      },
      {
        id: "f5sfsf8sf",
        menu: "Change Email",
        route: "/dashboard/change-email",
        permission: ["admin"],
      },
      {
        id: "sf4se8r9w",
        menu: "Popup Image",
        route: "/dashboard/popup-image",
        permission: ["admin"],
      },
      {
        id: "sf4kdjeuer9w",
        menu: "Manage ROI",
        route: "/dashboard/manage-roi",
        permission: ["admin"],
      },
      {
        id: "sf4kdkdkjeuehr9w",
        menu: "Manage Level Income",
        route: "/dashboard/manage-level-income",
        permission: ["admin"],
      },
      {
        id: "sf4kdkdkjeupdoej9w",
        menu: "Manage Profit Sharing ",
        route: "/dashboard/manage-profit-sharing",
        permission: ["admin"],
      },
      {
        id: "sf4kdkdkjdkdieueoej9w",
        menu: "Manage Deposit",
        route: "/dashboard/manage-deposit",
        permission: ["admin"],
      },
      {
        id: "4f7sfs8fs8f",
        menu: "Add User",
        route: "/dashboard/add-user",
        permission: ["admin"],
      },
      // {
      //   id: "4f7sfs8fskk",
      //   menu: "Gallery",
      //   route: "/dashboard/gallery",
      //   permission: ["admin"],
      // },
      // {
      //   id: "4f7sfs8fs00",
      //   menu: "Manage Photos",
      //   route: "/dashboard/gallery/manage-photos",
      //   permission: ["admin"],
      // },
      // {
      //   id: "4f7sfs8fs10",
      //   menu: "Manage Videos",
      //   route: "/dashboard/gallery/manage-videos",
      //   permission: ["admin"],
      // },
    ],
  },
];
